import { Page, Section } from 'ui';

import { useSupportIssueTitle } from '~/support/hooks/useSupportIssueTitle/useSupportIssueTitle';

import { SupportIssueForm } from '../../components/SupportIssueForm/SupportIssueForm';

export const SupportTicketCreate = () => {
  const title = useSupportIssueTitle();

  return (
    <Page>
      <Page.Title title={title} />
      <Page.Divider />
      <Section>
        <SupportIssueForm />
      </Section>
    </Page>
  );
};
